import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2daad5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading",
  role: "status"
}
const _hoisted_2 = {
  key: 1,
  class: "error",
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Oops! We couldn't find anything.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Try setting a different location.", -1))
const _hoisted_5 = { class: "no-results-options" }
const _hoisted_6 = {
  key: 2,
  class: "error",
  role: "status"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sorry, the event you were looking for is not currently available.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Keep scrolling to find another great gig!", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "error",
  role: "status"
}
const _hoisted_12 = {
  key: 4,
  class: "homepage-notifications",
  role: "status"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" You have ")
const _hoisted_15 = { href: "#saved-events" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Location is set to ", -1))
const _hoisted_19 = { class: "scroll-to-top-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_location_modal = _resolveComponent("location-modal")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_hero_section = _resolveComponent("hero-section")!
  const _component_primary_section = _resolveComponent("primary-section")!
  const _component_get_location_section = _resolveComponent("get-location-section")!
  const _component_get_bands_section = _resolveComponent("get-bands-section")!
  const _component_get_categories_section = _resolveComponent("get-categories-section")!
  const _component_get_genres_section = _resolveComponent("get-genres-section")!
  const _component_promoted_section = _resolveComponent("promoted-section")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { full: true }, {
    default: _withCtx(() => [
      (_ctx.status === 'pending')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_loading)
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'success' && _ctx.sections.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_location_modal, {
                "is-location-set": _ctx.isLocationSet,
                onLocationSetGeo: _cache[0] || (_cache[0] = 
            (e) =>
              _ctx.onLocationSet(
                e,
                'no-events-page--change-my-location-button',
                _ctx.i,
                'geo'
              )
          ),
                onLocationSetPostcode: _cache[1] || (_cache[1] = 
            (e) =>
              _ctx.onLocationSet(
                e,
                'no-events-page--change-my-location-button',
                _ctx.i,
                'postcode'
              )
          ),
                onLocationUnset: _cache[2] || (_cache[2] = 
            () =>
              _ctx.onLocationUnset('no-events-page--change-my-location-button', _ctx.i)
          )
              }, null, 8, ["is-location-set"]),
              _createElementVNode("button", {
                class: "primary-button",
                onClick: _cache[3] || (_cache[3] = 
            () => _ctx.onLocationUnset('no-events-page--see-national-button', _ctx.i)
          )
              }, " View national events ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'success' && _ctx.showEventNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.status === 'failure')
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Oops, something's gone wrong. Please try again in a few mintutes. "))
        : _createCommentVNode("", true),
      (_ctx.status === 'success' && _ctx.sections.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
            (_ctx.bookmarkedEvents.events.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.bookmarkedEvents.events.length) + " saved event(s).", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.bookmarkedEvents.events.length === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Click ❤️ to save events. "))
              : _createCommentVNode("", true),
            (_ctx.displayedLocation)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_font_awesome_icon, { icon: "map-marker-alt" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.displayedLocation), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, i) => {
        return (_openBlock(), _createElementBlock("section", {
          key: section.anchorLink,
          class: "full"
        }, [
          (i == 0)
            ? (_openBlock(), _createBlock(_component_hero_section, {
                key: 0,
                title: section.title,
                "anchor-link": section.anchorLink,
                events: section.events,
                "is-location-set": _ctx.isLocationSet,
                onSectionViewed: ($event: any) => (_ctx.onSectionViewed('hero-section', section.anchorLink, i)),
                onLocationSetGeo: (e) => _ctx.onLocationSet(e, 'hero-section', i, 'geo'),
                onLocationSetPostcode: 
          (e) => _ctx.onLocationSet(e, 'hero-section', i, 'postcode')
        ,
                onLocationUnset: () => _ctx.onLocationUnset('hero-section', i)
              }, null, 8, ["title", "anchor-link", "events", "is-location-set", "onSectionViewed", "onLocationSetGeo", "onLocationSetPostcode", "onLocationUnset"]))
            : (_openBlock(), _createBlock(_component_primary_section, {
                key: 1,
                title: section.title,
                "anchor-link": section.anchorLink,
                events: section.events,
                onSectionViewed: ($event: any) => (
          _ctx.onSectionViewed('primary-section', section.anchorLink, i)
        )
              }, null, 8, ["title", "anchor-link", "events", "onSectionViewed"])),
          (_ctx.isLocationSet === false && i === 0)
            ? (_openBlock(), _createBlock(_component_get_location_section, {
                key: 2,
                onLocationSetGeo: 
          (e) => _ctx.onLocationSet(e, 'get-location-section', i, 'geo')
        ,
                onLocationSetPostcode: 
          (e) => _ctx.onLocationSet(e, 'get-location-section', i, 'postcode')
        ,
                onLocationUnset: () => _ctx.onLocationUnset('get-location-section', i)
              }, null, 8, ["onLocationSetGeo", "onLocationSetPostcode", "onLocationUnset"]))
            : _createCommentVNode("", true),
          (_ctx.isBandsPreferencesSet === false && i === 2)
            ? (_openBlock(), _createBlock(_component_get_bands_section, {
                key: 3,
                onSubmitPreferences: 
          (e) => _ctx.onSubmitPreferencesBands(e, 'get-bands-section', i)
        ,
                onResetPreferences: 
          () => _ctx.onResetPreferencesBands('get-bands-section', i)
        
              }, null, 8, ["onSubmitPreferences", "onResetPreferences"]))
            : _createCommentVNode("", true),
          (_ctx.isCategoriesPreferencesSet === false && i === 4)
            ? (_openBlock(), _createBlock(_component_get_categories_section, {
                key: 4,
                onSubmitPreferences: 
          (e) => _ctx.onSubmitPreferencesCategories(e, 'get-categories-section', i)
        ,
                onResetPreferences: 
          () => _ctx.onResetPreferencesCategories('get-categories-section', i)
        
              }, null, 8, ["onSubmitPreferences", "onResetPreferences"]))
            : _createCommentVNode("", true),
          (_ctx.isGenrePreferencesSet === false && i === 6)
            ? (_openBlock(), _createBlock(_component_get_genres_section, {
                key: 5,
                onSubmitPreferences: 
          (e) => _ctx.onSubmitPreferencesGenres(e, 'get-genres-section', i)
        ,
                onResetPreferences: 
          () => _ctx.onResetPreferencesGenres('get-genres-section', i)
        
              }, null, 8, ["onSubmitPreferences", "onResetPreferences"]))
            : _createCommentVNode("", true),
          (i === 3)
            ? (_openBlock(), _createBlock(_component_promoted_section, {
                key: 6,
                id: _ctx.selectedPromotions[0].id,
                "text-description": _ctx.selectedPromotions[0].textDescription,
                "img-src": _ctx.selectedPromotions[0].imgSrc,
                url: _ctx.selectedPromotions[0].url,
                onClick: ($event: any) => (
          _ctx.onPromotedSectionClicked(
            'promoted-section',
            _ctx.selectedPromotions[0].id,
            i
          )
        ),
                onSectionViewed: ($event: any) => (
          _ctx.onSectionViewed('promoted-section', _ctx.selectedPromotions[0].id, i)
        )
              }, null, 8, ["id", "text-description", "img-src", "url", "onClick", "onSectionViewed"]))
            : _createCommentVNode("", true),
          (i === 6)
            ? (_openBlock(), _createBlock(_component_promoted_section, {
                key: 7,
                id: _ctx.selectedPromotions[1].id,
                "text-description": _ctx.selectedPromotions[1].textDescription,
                "img-src": _ctx.selectedPromotions[1].imgSrc,
                url: _ctx.selectedPromotions[1].url,
                onClick: ($event: any) => (
          _ctx.onPromotedSectionClicked(
            'promoted-section',
            _ctx.selectedPromotions[1].id,
            i
          )
        ),
                onSectionViewed: ($event: any) => (
          _ctx.onSectionViewed('promoted-section', _ctx.selectedPromoted[1].id, i)
        )
              }, null, 8, ["id", "text-description", "img-src", "url", "onClick", "onSectionViewed"]))
            : _createCommentVNode("", true),
          (i === _ctx.sections.length - 1 && _ctx.bookmarkedEvents.events.length > 0)
            ? (_openBlock(), _createBlock(_component_primary_section, {
                key: _ctx.bookmarkedEventKeys.toString(),
                title: _ctx.bookmarkedEvents.title,
                "anchor-link": _ctx.bookmarkedEvents.anchorLink,
                events: _ctx.bookmarkedEvents.events,
                onSectionViewed: ($event: any) => (
          _ctx.onSectionViewed('primary-section', _ctx.bookmarkedEvents.anchorLink, i)
        )
              }, null, 8, ["title", "anchor-link", "events", "onSectionViewed"]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.status === 'success' && _ctx.sections.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "primary-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToTop()))
            }, " Scroll to top "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}